import { SelectOption } from "@interfaces/misc"
import { Control } from "react-hook-form"

export interface FormInputProps {
  name: string
  control: Control<any>
  label: string
  placeHolder?: string
}

export interface FormSelectProps {
  name: string
  label: string
  placeholder: string
  options: SelectOption[]
  control: Control<any>
}

export * from "./Checkbox"
export * from "./MultiSelect"
export * from "./PhoneInput"
export * from "./FormSelect"
export * from "./TextAreaInput"
export * from "./TextField"
